export class RuntimeError extends Error {
    constructor(public code: string, message: string) {
        super(message);
    }
}
